var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuError = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 6H7l1 4zM8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.715 2.858c-.777-1.294-2.653-1.294-3.43 0L.818 11.971C.018 13.304.978 15 2.533 15h10.935c1.554 0 2.515-1.696 1.715-3.03zm4.61 9.627L8.858 3.373a1 1 0 0 0-1.715 0l-5.468 9.112A1 1 0 0 0 2.533 14h10.935a1 1 0 0 0 .857-1.515",
  clipRule: "evenodd"
})));
export default SvgMenuError;